import React, { useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { hasVisibleText } from "../../helper/text";

// Rich text from the editor collapsed to a few lines, with "Show more" when it does not fit.
const CollapsibleTextSection = ({
  title,
  html,
  collapsedHeight = 168,
  className = "",
}) => {
  const { t } = useTranslation();
  const contentRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [overflows, setOverflows] = useState(false);

  const hasText = hasVisibleText(html);

  useLayoutEffect(() => {
    const content = contentRef.current;
    if (!content) {
      return undefined;
    }
    const measure = () => setOverflows(content.scrollHeight > collapsedHeight + 1);
    measure();
    if (typeof ResizeObserver === "undefined") {
      return undefined;
    }
    const observer = new ResizeObserver(measure);
    observer.observe(content);

    return () => observer.disconnect();
  }, [html, collapsedHeight]);

  if (!hasText) {
    return null;
  }

  const collapsed = overflows && !expanded;

  return (
    <section className={`text-section ${className}`}>
      {title && <h3 className='text-section__title'>{title}</h3>}
      <div
        ref={contentRef}
        className={`text-section__content ${
          collapsed ? "text-section__content--collapsed" : ""
        }`}
        style={collapsed ? { maxHeight: collapsedHeight } : undefined}
      >
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
      {overflows && (
        <button
          type='button'
          className='property-amenities__toggle text-section__toggle'
          aria-expanded={expanded}
          onClick={() => setExpanded((value) => !value)}
        >
          {expanded ? t("show_less", "Show less") : t("show_more", "Show more")}
        </button>
      )}
    </section>
  );
};

export default CollapsibleTextSection;
